<script lang="ts" setup>
  import type { PropType } from 'vue';
  import { useBreakpoints } from '@storefront/storefront';
  import { StoreLayout, AccountLayout } from '@storefront/components';

  type Affiliate = {
    order_spent_points: number;
    order_per_currency_points: number;
  }

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });

  defineProps({
    url: { type: String, required: false },
    affiliate: { type: Object as PropType<Affiliate>, required: false },
  });

  const breakpoints = useBreakpoints();
</script>
<template>
  <AccountMobileNavigation :href="$route('web.account.show')">
    {{ $t('SHOP.ACCOUNT.HEADER.AFFILIATE_PROGRAM') }}
  </AccountMobileNavigation>
  <SfTile v-if="affiliate" class="account-affiliate" large>
    <template v-if="breakpoints.lg" #title>
      <h1 v-if="breakpoints.lg" class="account-heading account-affiliate__heading">
        {{ $t('SHOP.ACCOUNT.HEADER.AFFILIATE_PROGRAM') }}
      </h1>
    </template>
    <template #default>
      <section class="account-affiliate__section">
        <p class="account-affiliate__text">{{ $t('SHOP.ACCOUNT.MESSAGE.AFFILIATE_PROGRAM_LINK_NOTICE') }}</p>
        <p class="account-affiliate__url">{{ url }}</p>
      </section>
      <section class="account-affiliate__section">
        <p class="account-affiliate__text">{{ $t('SHOP.ACCOUNT.HEADER.AFFILIATE_PROGRAM_BENEFITS') }}</p>
        <table class="account-affiliate__table">
          <tbody class="account-affiliate__table-body">
            <tr class="account-affiliate__table-body-row">
              <th class="account-affiliate__table-body-row" scope="row">{{ $t('SHOP.ACCOUNT.LABEL.AFFILIATE_PROGRAM_POINTS_PER_ORDER') }}</th>
              <td class="account-affiliate__table-body-desc">{{ affiliate.order_spent_points }}</td>
            </tr>
            <tr class="account-affiliate__table-body-row">
              <th class="account-affiliate__table-body-row" scope="row">{{ $t('SHOP.ACCOUNT.LABEL.AFFILIATE_PROGRAM_POINTS_PER_CURRENCY') }}</th>
              <td class="account-affiliate__table-body-desc">{{ affiliate.order_per_currency_points }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </template>
  </SfTile>
  <SfTile v-else class="account-affiliate" large>
    <template v-if="breakpoints.lg" #title>
      <h1 v-if="breakpoints.lg" class="account-heading account-affiliate__heading">
        {{ $t('SHOP.ACCOUNT.HEADER.AFFILIATE_PROGRAM') }}
      </h1>
    </template>
    <template #default>
      <div class="account-affiliate__section">
        <p class="account-affiliate__text">
          {{ $t('SHOP.ACCOUNT.HEADER.AFFILIATE_PROGRAM') }}
        </p>
      </div>
      <div class=" account-affiliate__section-button">
        <SfButton :href="$route('web.contact.index')" primary>
          {{ $t('SHOP.ACTION.CONTACT') }}
        </SfButton>
      </div>
    </template>
  </SfTile>

  <RouterView />
</template>
<style lang="scss">
  .account-affiliate {

    &__section {
      margin-bottom: 0.75rem;
    }

    &__text {
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }

    &__url {
      font-weight: var(--font-weight-bold);
    }

    &__table {
      border-collapse: collapse;
      border: 1px solid var(--sf-account-color-black);
      margin-top: 0.625rem;
    }

    &__table-body-row {
      background-color: var(--sf-account-color-light-background);
      padding: 0.5rem;
      text-align: left;
      border: 1px solid var(--sf-account-color-black);
    }

    &__table-body-desc {
      padding: 0.5rem;
    }

    &__section-button {
      text-align: right;
    }

  }
</style>
